import { useContext, useEffect, useState } from "react"
import { WebSocketContext } from "../../Providers/WebSocket/WebSocketContext"
import { Grid, Typography, Chip, Box } from "@mui/material"
import OneInput from "../OneInput/OneInput"
import OneButton from "../OneButton/OneButton"
import { Search } from "@mui/icons-material"
import { sxChipSelect } from "../../Pages/ConfiguracoesPage/EquipesConfig/CadastroEquipe/UsuarioSelect/SxUsuarioSelect"
import OneSelect from "../OneSelect/OneSelect"
import { tiposBusquedaEquipe } from "../../Utils/optionsSelects"

const EquipeUsuario = ({ dadosUsuario }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const [equipes, setEquipes] = useState([])
    const [formData, setFormData] = useState({ select: tiposBusquedaEquipe[0].id, input: '' })

    const listaEquipe = (msg) => {
        const response = msg.data.dadosEquipes.equipeProcesada
        if (msg.data && msg.data.status) {
            setEquipes(response)
        }
    }

    useEffect(() => {
        addRoute("buscarEquipeUsuario", listaEquipe)
        sendWs('buscarEquipeUsuario', { filtros: { id_usuario: dadosUsuario.id } })
    }, [])

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.name == 'tipo') {
                setFormData({ ...formData, select: event.target.value })
            }
            if (event.target.name == 'pesquisa') {
                setFormData({ ...formData, input: event.target.value })
            }
        }
    }

    const handleSearch = (e) => {
        e.preventDefault()
        switch (formData.select) {
            case 1:
                sendWs('buscarEquipeUsuario', { filtros: { id_usuario: dadosUsuario.id, nome: formData.input } })
                break
            case 2:
                sendWs('buscarEquipeUsuario', { filtros: { id_usuario: dadosUsuario.id, condominio: formData.input } })
                break
            case 3:
                sendWs('buscarEquipeUsuario', { filtros: { id_usuario: dadosUsuario.id, evento: formData.input } })
                break
        }
    }

    return (
        <>
            <Grid container
                xs={12}
                sx={{
                    width: '100%', height: '100%', display: 'flex', flexFlow: 'column'
                }}
                flexDirection="column" rowGap={1}
            >
                <Grid>

                    <form onSubmit={handleSearch} style={{ padding: 0, margin: 0 }}>
                        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'flex-start', gap: '10px' }}>
                            <Grid xs={2} sx={{ height: "100%" }}>
                                <OneSelect
                                    options={tiposBusquedaEquipe}
                                    defaultValue={tiposBusquedaEquipe[0].id}
                                    name="tipo"
                                    onChange={handleChange}
                                />

                            </Grid>
                            <Grid xs={9} container sx={{ gap: '10px' }} >
                                <Grid xs={6} sm={6} >
                                    <OneInput
                                        onChange={handleChange}
                                        newSx={{ height: '32px', width: '100%' }}
                                        name="pesquisa"
                                    />
                                </Grid>
                                <Grid xs={4} sm={3}>
                                    <OneButton
                                        id="button"
                                        color="one_primary"
                                        variant="contained"
                                        type="submit"
                                        IconStart={Search}
                                        onClick={handleSearch}
                                    >
                                    Pesquisar
                                    </OneButton>
                                </Grid>
                            </Grid>
                        </Grid >
                    </form>

                    <hr style={{ border: 'solid rgb(160, 160, 160) 1px', width: '100%' }} />
                    <Grid>
                        {equipes.length > 0
                            ? equipes.map((obj, index) => (
                                <Grid key={index} xs={12}>
                                    <Grid sx={{ marginBottom: '3px' }}>
                                        <Typography fontWeight="600">Equipe: {obj.nomeEquipe}</Typography>
                                    </Grid>
                                    {
                                        <Box >
                                            {
                                                obj.condominios.length > 0
                                                    ? <>
                                                        <Grid>
                                                            <Typography sx={{ marginLeft: '10px' }} fontWeight="500">Condominios:</Typography>
                                                        </Grid>
                                                        <Box sx={{ borderRadius: '5px', gap: '10px ', backgroundColor: 'white', display: 'flex', justifyItems: 'center', marginLeft: '10px', height: '100%', width: '100%', padding: '10px' }}>
                                                            {obj.condominios.length > 0
                                                                ? obj.condominios.map((value) => (
                                                                    <>
                                                                        <Box sx={{ margin: '0,5%' }}>
                                                                            <Chip
                                                                                sx={sxChipSelect}
                                                                                label={value.nomeCond} />
                                                                        </Box>
                                                                    </>
                                                                ))
                                                                : ''
                                                            }
                                                        </Box>
                                                    </>
                                                    : ''
                                            }
                                        </Box>
                                    }
                                    {
                                        <Box >
                                            {
                                                obj.eventos.length > 0
                                                    ? <>
                                                        <Grid>
                                                            <Typography sx={{ marginLeft: '10px' }} fontWeight="500">Eventos:</Typography>
                                                        </Grid>
                                                        <Box sx={{ borderRadius: '5px', gap: '10px ', backgroundColor: 'white', display: 'flex', justifyItems: 'center', marginLeft: '10px', height: '100%', width: '100%', padding: '10px' }}>
                                                            {obj.eventos.length > 0
                                                                ? obj.eventos.map((value) => (
                                                                    <>
                                                                        <Box sx={{ margin: '0,5%' }}>
                                                                            <Chip
                                                                                sx={sxChipSelect}
                                                                                label={value.nomeEvento} />
                                                                        </Box>
                                                                    </>
                                                                ))
                                                                : ''
                                                            }
                                                        </Box>
                                                    </>
                                                    : ''
                                            }
                                        </Box>
                                    }
                                </Grid>
                            ))
                            : <Typography>Não tem Equipe</Typography>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default EquipeUsuario
